import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    showClose: false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.modalTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString($setup.modalDescription), 1)
        ]),
        _createElementVNode("div", { class: "modal-actions" }, [
          _createElementVNode("button", {
            class: "btn cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn confirm",
            onClick: $setup.confirm
          }, "Confirm")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}